module.exports = __webpack_public_path__ + "img/tmb_ch_arkhan_0.f4abc23e.png";